import { reactive, watch } from 'vue';
export const useEditorProxy = props => {
  const options = reactive({
    save: '',
    // ({ id, data}) => {} 数据保存接口
    query: '',
    // ({ id }) => data 数据查询接口
    queryParams: {},
    // 查询附带参数
    afterQuery: null,
    // ({ params, data }) => data, // 查询后的数据处理函数
    beforeSave: null,
    // ({formData}) => formData||false // 编辑前,返回false,取消保存
    afterSave: null // ({formData, result}) => result, 保存后// 返回false取消刷新
  });
  watch(() => props.editConfig, val => {
    Object.assign(options, val);
  }, {
    immediate: true,
    deep: true
  });
  const {
    loading: getDetailLoading,
    error: getDetailError,
    runAsync: queryDetailAsync
  } = fetchApi(options.query);
  const {
    loading: saveLoading,
    error: saveError,
    runAsync: saveAsync
  } = fetchApi(options.save);

  // 获取数据详情
  const getDetail = async ({
    id,
    row
  }) => {
    getDetailError.value = '';
    if (!options.query || getDetailLoading.value) return Promise.resolve(false);
    const postParams = {};
    if (typeof options.queryParams === 'function') {
      const tmp = await options.queryParams({
        id,
        row
      });
      Object.assign(postParams, tmp);
    } else if (typeof options.queryParams === 'object') {
      Object.assign(postParams, options.queryParams);
    } else {
      Object.assign(postParams, {
        id,
        ...row
      });
    }
    const {
      error,
      ...data
    } = await queryDetailAsync(postParams);
    if (error) {
      getDetailError.value = error;
      return Promise.resolve(false);
    }
    if (typeof options.afterQuery === 'function') {
      const resultData = await options.afterQuery({
        params: postParams,
        data
      });
      return Promise.resolve(resultData);
    }
    return Promise.resolve(data);
  };
  const save = async formData => {
    saveError.value = '';
    if (!options.save || saveLoading.value) return Promise.resolve(false);
    const postData = {};
    if (typeof options.beforeSave === 'function') {
      const tmp = await options.beforeSave({
        formData
      });
      if (!tmp) return Promise.resolve(false);
      Object.assign(postData, tmp);
    } else {
      Object.assign(postData, formData);
    }
    const {
      error,
      ...res
    } = await saveAsync(postData);
    if (error) {
      saveError.value = error;
      return Promise.resolve(false);
    }
    if (typeof options.afterSave === 'function') {
      const ret = await options.afterSave({
        formData,
        result: res
      });
      return Promise.resolve(ret);
    }
    return Promise.resolve(res);
  };
  return {
    getDetail,
    save,
    saveLoading,
    saveError,
    getDetailLoading,
    getDetailError
  };
};